import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  content: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8f8f8',
    fontSize: '18px',
    color: '#333',
  },
})
